import React, { useState, useRef } from 'react';
import { StatusBar, TextInput, View, Text, ScrollView, Pressable, Alert, useWindowDimensions } from 'react-native';
import { colors } from '../common/color';
import { CustomConsole, HeaderComponent, FooterComponent, getDMSansBoldFont, getDMSansLightFont, validateEmail, getDMSansRegularFont, scrollToTop, CustomProgressBar } from '../common/utils';
import { CARTLIST, CMSPAGE, LOGIN, SENDOTP } from '../common/webUtils';
import { EMAIL, FIRST_NAME, LAST_NAME, OTP_VERIFY, PASSWORD, PHONE, USER_ID, saveSession, getSession } from '../common/LocalStorage';
import { Image } from 'react-native';
import { useIsFocused } from '../common/routerShim';
import { Divider } from 'react-native-paper';
import RenderHTML from 'react-native-render-html';
import { styles, ids } from '../common/responsive.js';

function CommonScreen({ navigation, route }) {

    const { width } = useWindowDimensions();

    const scrollRef = useRef();
    const cmspageNo = route.params.paramInfoId;

    const [loading, setLoading] = useState(false);
    const [userId, setUserId] = useState('');
    const [cartLength, setcartLength] = React.useState('0');
    const [description, setDescription] = React.useState('');

    //for check screen focused
    const isFocused = useIsFocused();

    //useeffect
    React.useEffect(() => {
        getSessionData();
        scrollToTop();
    }, [isFocused, cmspageNo])

    // get sessiondata
    const getSessionData = async () => {
        try {
            const user_id = await getSession(USER_ID);
            setUserId(user_id);
            cartListApi();
            cmsPageApi();
        } catch (error) {

        }
    }

    // cart list api
    const cartListApi = async () => {
        try {
            const user_id = await getSession(USER_ID);
            var raw = JSON.stringify({
                "customer_id": user_id
            });

            var requestOptions = {
                method: 'POST',
                body: raw,
            };

            CustomConsole(CARTLIST);

            // setLoading(true);
            fetch(CARTLIST, requestOptions)
                .then(response => response.json())
                .then((json) => {
                    CustomConsole(json);

                    setcartLength(json.data.cart.length);
                    CustomConsole("Cart length" + cartLength)
                    // setLoading(false);
                })
                .catch((error) => {
                    setLoading(false);
                    CustomConsole("Cart Api Error=>" + error);
                });
        } catch (e) {
            CustomConsole("Cart Exception=>" + e + "");
        }
    }

    // common page api
    const cmsPageApi = async () => {
        try {

            var requestOptions = {
                method: 'GET',
                redirect: 'follow'
            };

            CustomConsole(CMSPAGE + cmspageNo);

            setLoading(true);
            fetch(CMSPAGE + cmspageNo, requestOptions)
                .then(response => response.json())
                .then((json) => {
                    CustomConsole(json);

                    setDescription((json.data.description).replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&'));
                    setLoading(false);
                })
                .catch((error) => {
                    setLoading(false);
                    CustomConsole("Cms Page Api Error=>" + error);
                });
        } catch (e) {
            setLoading(false);
            CustomConsole("Cms Page Exception=>" + e + "");
        }
    }

    return (
        <View>
            <StatusBar barStyle="dark-content" />
            <ScrollView ref={scrollRef} style={styles.container} dataSet={{media:ids.container}} keyboardShouldPersistTaps='handled'>
                <View style={{}}>

                    {/* progress view */}
                    {loading ? CustomProgressBar(loading) : null}
                    {/* end of progress view */}

                    {/* Header view */}
                    {HeaderComponent(cartLength, navigation, userId)}
                    {/* end of Header view */}

                    {/* main view */}
                    <View style={styles.commonMainView} dataSet={{media:ids.commonMainView}}>
                        <RenderHTML
                            contentWidth={width}
                            source={{ html: description }}
                            tagsStyles={tagsStyles}
                            systemFonts={[getDMSansRegularFont()]}
                            baseStyle={styles.commonScreenText} dataSet={{media:ids.commonScreenText}}
                        />
                    </View>
                    {/* end of main view */}

                    {/* Footer view */}
                    {/* {FooterComponent(navigation, userId)}*/}
                    {/* end of Footer view */}

                </View>

            </ScrollView>
        </View>
    );
};

export default CommonScreen;

const tagsStyles = {
    p: styles.pTagWithBlackText,
    div: styles.divTag
}
